import { Link } from "react-router-dom";
import { SERVICES } from "../../data/services";
import { LogoMark } from "./Logo";
import { ACCOUNT_URL, DMS_URL } from "./Nav";

export const CONTACT = {
  phone: "+91 77460 00066",
  tel: "+917746000066",
  email: "bhisminfratech@gmail.com",
  address: "Head Office: Village Mundsa, Distt. Jhajjar, Haryana 124106",
  branch: "Branch Office: Plot No. 102, New Palam Vihar, Gurgaon, Haryana",
};

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/10 bg-[var(--ink)] pt-20" data-testid="site-footer">
    <div className="mx-auto grid max-w-[1440px] gap-12 px-5 md:grid-cols-12 md:px-10">
      <div className="md:col-span-5">
        <LogoMark className="h-12 w-12" />
        <p className="mt-6 max-w-sm text-[var(--bone-2)]">
          BHISM INFRATECH PRIVATE LIMITED — manpower, records and logistics for businesses that need the work done right, every shift.
        </p>
        <p className="mt-6 overline text-[var(--bone-2)]">Director — Brijpal Singh</p>
      </div>
      <div className="md:col-span-4">
        <p className="overline text-[var(--signal)]">Services</p>
        <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link to={`/services/${s.slug}`} className="text-[var(--bone)] transition-colors hover:text-[var(--signal)]" data-testid={`footer-service-${s.slug}`}>
                {s.short}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-3 text-sm">
        <p className="overline text-[var(--signal)]">Contact</p>
        <ul className="mt-5 space-y-3 text-[var(--bone)]">
          <li><a href={`tel:${CONTACT.tel}`} data-testid="footer-phone" className="hover:text-[var(--signal)]">{CONTACT.phone}</a></li>
          <li><a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="break-all hover:text-[var(--signal)]">{CONTACT.email}</a></li>
          <li data-testid="footer-address" className="text-[var(--bone-2)]">{CONTACT.address}</li>
          <li data-testid="footer-branch" className="text-[var(--bone-2)]">{CONTACT.branch}</li>
        </ul>
        <div className="mt-6 flex flex-wrap gap-5">
          <a href={DMS_URL} target="_blank" rel="noopener noreferrer" className="text-[var(--brand-blue)] underline-offset-4 hover:underline" data-testid="footer-cloud-dms-link">Cloud DMS</a>
          <a href={ACCOUNT_URL} target="_blank" rel="noopener noreferrer" className="text-[var(--brand-blue)] underline-offset-4 hover:underline" data-testid="footer-account-link">Account</a>
          <Link to="/careers" className="underline-offset-4 hover:underline" data-testid="footer-careers-link">Careers</Link>
          <Link to="/employee/login" className="text-[var(--bone-2)] underline-offset-4 hover:underline" data-testid="footer-employee-link">Employee login</Link>
          <Link to="/admin/login" className="text-[var(--bone-2)] underline-offset-4 hover:underline" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </div>
    <div className="mx-auto mt-16 flex max-w-[1440px] flex-col justify-between gap-2 px-5 font-mono text-xs text-[var(--bone-2)] md:flex-row md:px-10">
      <span>© {new Date().getFullYear()} BHISM INFRATECH PRIVATE LIMITED</span>
      <span>People · Paper · Pallets</span>
    </div>
    <p aria-hidden="true" className="pointer-events-none mt-4 select-none text-center font-display text-[31vw] font-black leading-[0.75] tracking-tight text-[var(--ink-3)]">
      BHISM
    </p>
  </footer>
);
